import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../../Config';
import AddIATA from './IATAOffcanvas/AddIATA';
import { getIATAAirline, getOrganisationIATAList, getOrganisationREGList } from '../../../../Redux/action/Organisation/OrganisationListAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import EditIATA from './IATAOffcanvas/EditIATA';
import Swal from 'sweetalert2';
import EditReg from './RegOffcanvas/EditReg';
import { getBranchList } from '../../../../Redux/action/Organisation/Branch/BranchAction';
import { convertInputToCalender, DDMMMYYYYformateDate } from '../../../../HelperFunctions';


const RegTab = ({ token, user_id, b64id, refresh }) => {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [editRegObject, setEditRegObject] = useState(false);
    const [iata_organisation_id, set_iata_organisation_id] = useState("");
    const [addEdit, setAddEdit] = useState("add");
    const [branchList, setBranchList] = useState([]);

    const [binObj, setBinObj] = useState({});
    const [cinObj, setCinObj] = useState({});
    const [cstObj, setCstObj] = useState({});
    const [stRegObj, setStRegObj] = useState({});
    const [tanObj, setTanObj] = useState({});
    const [vatObj, setVatObj] = useState({});
    const [gstObj, setGstObj] = useState({});
    const [ieCodeObj, setIeCodeObj] = useState({});
    const [panObj, setPanObj] = useState({});

    //add modal
    const [showAdd, setShowAdd] = useState(false);
    const handleOpenAddModal = () => { setShowAdd(true) }
    const handleCloseAddModal = () => { setShowAdd(false) }


    //edit modal
    const [showEdit, setShowEdit] = useState(false);
    const handleOpenEditModal = () => { setShowEdit(true) }
    const handleCloseEditModal = () => { setShowEdit(false) }


    //organisation options

    useEffect(() => {
        if (user_id && token && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getOrganisationREGList(token, user_id, id))
                dispatch(getBranchList(token, user_id, id))
            }
        }
    }, [token, user_id]);

    const refreshREG = () => {
        try {
            if (user_id && token && b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getOrganisationREGList(token, user_id, id))
                    // dispatch(getBranchList(token, user_id, id))
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const { loadingOrganisationREGList, OrganisationREGList, OrganisationREGListError } = useSelector(state => state?.OrganisationListReducer);
    const { loadingBranchList, BranchListError, BranchList } = useSelector(state => state?.BranchReducer);




    useEffect(() => {
        if (BranchList) {
            let arr = [];
            BranchList.map(val => { arr.push({ id: val.id, name: val.branch_name }) })
            setBranchList(arr);
        }
    }, [BranchList])


    useEffect(() => {
        if (loadingOrganisationREGList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        const binNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "BIN NO");
        if (binNoObject) {
            setBinObj(binNoObject);
        } else {
            setBinObj({});
        }

        const cinNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "CIN NO");
        if (cinNoObject) {
            setCinObj(cinNoObject);
        } else {
            setCinObj({});
        }

        const cstNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "CST NO");
        if (cstNoObject) {
            setCstObj(cstNoObject);
        } else {
            setCstObj({});
        }

        const stRegNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "ST REG NO");
        if (stRegNoObject) {
            setStRegObj(stRegNoObject);
        } else {
            setStRegObj({});
        }

        const tanNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "TAN NO");
        if (tanNoObject) {
            setTanObj(tanNoObject);
        } else {
            setTanObj({});
        }

        const vatNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "VAT NO");
        if (vatNoObject) {
            setVatObj(vatNoObject);
        } else {
            setVatObj({});
        }

        const panNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "PAN NO");
        if (panNoObject) {
            setPanObj(panNoObject);
        } else {
            setPanObj({});
        }

        const gstNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "GSTIN");
        if (gstNoObject) {
            setGstObj(gstNoObject);
        } else {
            setGstObj({});
        }

        const ieCodeNoObject = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === "IE CODE NO");
        if (ieCodeNoObject) {
            setIeCodeObj(ieCodeNoObject);
        } else {
            setIeCodeObj({});
        }

    }, [loadingOrganisationREGList, OrganisationREGList, OrganisationREGListError]);

    const handleEditIATA = (registration_type) => {
        if (branchList.length == 0) {
            toast.error("Please add a branch first.")
        } else {
            const foundObj = OrganisationREGList && OrganisationREGList.find(item => item.registration_type === registration_type);

            if (foundObj) {
                setAddEdit("update");
                setEditRegObject({
                    id: foundObj.id,
                    registration_type: registration_type,
                    registration_no: foundObj.registration_no,
                    branch_id: foundObj.branch_id,
                    registration_date: foundObj.registration_date ? convertInputToCalender(foundObj?.registration_date) : "",
                    valid_upto: foundObj.valid_upto ? convertInputToCalender(foundObj?.valid_upto) : ""
                });
            } else {
                setAddEdit('add');
                setEditRegObject({
                    registration_type: registration_type,
                    registration_no: "",
                    branch_id: "",
                    registration_date: "",
                    valid_upto: ""
                });
            }

            setShowEdit(true);
        }


    }



    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className='card p-3'>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">Registration Type</th>
                                            <th scope="col">Branch</th>
                                            <th scope="col">Registration No</th>
                                            <th scope="col">Valid Date</th>
                                            <th scope="col">Valid Upto</th>
                                            <th scope="col">Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">BIN NO.</th>
                                            <td>{binObj && binObj.customer_branch ? binObj.customer_branch.branch_name : "-"}</td>
                                            <td>{binObj && binObj.registration_no}</td>
                                            <td>{binObj && binObj.registration_date && DDMMMYYYYformateDate(binObj.registration_date)}</td>
                                            <td>{binObj && binObj.valid_upto && DDMMMYYYYformateDate(binObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("BIN NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">CIN NO.</th>
                                            {/* <td>{cinObj && cinObj.branch_id}</td> */}
                                            <td>{cinObj && cinObj.customer_branch ? cinObj.customer_branch.branch_name : "-"}</td>
                                            <td>{cinObj && cinObj.registration_no}</td>
                                            <td>{cinObj && cinObj.registration_date && DDMMMYYYYformateDate(cinObj.registration_date)}</td>
                                            <td>{cinObj && cinObj.valid_upto && DDMMMYYYYformateDate(cinObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("CIN NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">CST NO.</th>
                                            {/* <td>{cstObj && cstObj.branch_id}</td> */}
                                            <td>{cstObj && cstObj.customer_branch ? cstObj.customer_branch.branch_name : "-"}</td>
                                            <td>{cstObj && cstObj.registration_no}</td>
                                            <td>{cstObj && cstObj.registration_date && DDMMMYYYYformateDate(cstObj.registration_date)}</td>
                                            <td>{cstObj && cstObj.valid_upto && DDMMMYYYYformateDate(cstObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("CST NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">ST REG NO.</th>
                                            {/* <td>{stRegObj && stRegObj.branch_id}</td> */}
                                            <td>{stRegObj && stRegObj.customer_branch ? stRegObj.customer_branch.branch_name : "-"}</td>
                                            <td>{stRegObj && stRegObj.registration_no}</td>
                                            <td>{stRegObj && stRegObj.registration_date && DDMMMYYYYformateDate(stRegObj.registration_date)}</td>
                                            <td>{stRegObj && stRegObj.valid_upto && DDMMMYYYYformateDate(stRegObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("ST REG NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">TAN NO.</th>
                                            {/* <td>{tanObj && tanObj.branch_id}</td> */}
                                            <td>{tanObj && tanObj.customer_branch ? tanObj.customer_branch.branch_name : "-"}</td>
                                            <td>{tanObj && tanObj.registration_no}</td>
                                            <td>{tanObj && tanObj.registration_date && DDMMMYYYYformateDate(tanObj.registration_date)}</td>
                                            <td>{tanObj && tanObj.valid_upto && DDMMMYYYYformateDate(tanObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("TAN NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">VAT NO.</th>
                                            {/* <td>{vatObj && vatObj.branch_id}</td> */}
                                            <td>{vatObj && vatObj.customer_branch ? vatObj.customer_branch.branch_name : "-"}</td>
                                            <td>{vatObj && vatObj.registration_no}</td>
                                            <td>{vatObj && vatObj.registration_date && DDMMMYYYYformateDate(vatObj.registration_date)}</td>
                                            <td>{vatObj && vatObj.valid_upto && DDMMMYYYYformateDate(vatObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("VAT NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">GSTIN</th>
                                            {/* <td>{gstObj && gstObj.branch_id}</td> */}
                                            <td>{gstObj && gstObj.customer_branch ? gstObj.customer_branch.branch_name : "-"}</td>
                                            <td>{gstObj && gstObj.registration_no}</td>
                                            <td>{gstObj && gstObj.registration_date && DDMMMYYYYformateDate(gstObj.registration_date)}</td>
                                            <td>{gstObj && gstObj.valid_upto && DDMMMYYYYformateDate(gstObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("GSTIN") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">IE CODE NO</th>
                                            {/* <td>{ieCodeObj && ieCodeObj.branch_id}</td> */}
                                            <td>{ieCodeObj && ieCodeObj.customer_branch ? ieCodeObj.customer_branch.branch_name : "-"}</td>
                                            <td>{ieCodeObj && ieCodeObj.registration_no}</td>
                                            <td>{ieCodeObj && ieCodeObj.registration_date && DDMMMYYYYformateDate(ieCodeObj.registration_date)}</td>
                                            <td>{ieCodeObj && ieCodeObj.valid_upto && DDMMMYYYYformateDate(ieCodeObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("IE CODE NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">PAN NO</th>
                                            {/* <td>{panObj && panObj.branch_id}</td> */}
                                            <td>{panObj && panObj.customer_branch ? panObj.customer_branch.branch_name : "-"}</td>
                                            <td>{panObj && panObj.registration_no}</td>
                                            <td>{panObj && panObj.registration_date && DDMMMYYYYformateDate(panObj.registration_date)}</td>
                                            <td>{panObj && panObj.valid_upto && DDMMMYYYYformateDate(panObj.valid_upto)}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditIATA("PAN NO") }}><i className="fas fa-edit"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <EditReg show={showEdit} handleClose={handleCloseEditModal} refreshREG={refreshREG} token={token} user_id={user_id} b64id={b64id} editRegObject={editRegObject} addEdit={addEdit} branchList={branchList} />
                    </div>
            }

        </>


    )
}

export default RegTab